import { render } from "./TopBarDeletingMessagesButtons.vue?vue&type=template&id=6cbec604&scoped=true"
import script from "./TopBarDeletingMessagesButtons.vue?vue&type=script&lang=js"
export * from "./TopBarDeletingMessagesButtons.vue?vue&type=script&lang=js"

import "./TopBarDeletingMessagesButtons.vue?vue&type=style&index=0&id=6cbec604&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cbec604"]])

export default __exports__